<template>
  <vnt-listview selectionMode="single">
    <vnt-listview-item
      v-for="category in categories"
      :key="category.name"
      :item="category"
      @pick="editCategory">
      {{ category.name }}
    </vnt-listview-item>
  </vnt-listview>
</template>

<script>
import { listCategories } from '../../services/categories'

export default {
  name: 'CategoriesList',

  data() {
    return {
      categories: []
    }
  },

  methods: {
    editCategory(category) {
      this.$router.push('/categories/' + category.id)
    }
  },

  mounted() {
    listCategories().then((categories) => {
      this.categories = categories
    })
  }
}
</script>
